// In Vuetify 2, if v-text-field has "data-cc" property, it's being rendered directly in <input> tag
// In Vuetify 3 "data-cc" is right in a root vuetify text field element with "v-input" class
const vuetifyInputReplacer = (inputClass, dataCc) => {
  // inputClass is mandatory to find an appropriate v-text-field
  const vuetifyInput = document.querySelector(`.v-input.${inputClass} input`);
  if (vuetifyInput) vuetifyInput.setAttribute('data-cc', dataCc);
};

export { vuetifyInputReplacer };
